// @flow
import * as React from 'react';
import style from './style';

const Footer = (): React.Element<any> => (
  <footer style={style.style}><small>&#169; 2017 Virtual Assistant B.V.</small></footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/scenes/components/Footer/Footer.js